<ng-template #popupTemplate>
    <div [ngClass]="className">
        <ng-container *ngIf="!hidden">
            <ng-content></ng-content>
        </ng-container>
    </div>
</ng-template>
